import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cards: [],
  loading: false,
  error: null,
};

const authorCardsSlice = createSlice({
  name: 'author_cards',
  initialState,
  reducers: {
    setAuthorCards: (state, action) => {
      state.cards = Array.isArray(action.payload) ? action.payload : [];
    },
    clearAuthorCards: (state) => {
      state.cards = [];
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setAuthorCards, clearAuthorCards, setLoading, setError } = authorCardsSlice.actions;

export default authorCardsSlice.reducer;
